'use client'

import type { ReactNode } from 'react'
import { createContext, useContext, useMemo, useState } from 'react'

import { poppins } from '~/font'
import { SignInModal } from '~/lib/navbar/sign-in-modal'
import { SignUpModal } from '~/lib/navbar/sign-up-modal'

interface AuthModalsValue {
  openSignIn: () => void
  openSignUp: () => void
}

const AuthModalsContext = createContext<AuthModalsValue | null>(null)

export function AuthModalsProvider({ children }: { children: ReactNode }) {
  const [signInOpen, setSignInOpen] = useState(false)
  const [signUpOpen, setSignUpOpen] = useState(false)

  const value = useMemo(() => ({ openSignIn: () => setSignInOpen(true), openSignUp: () => setSignUpOpen(true) }), [])

  return (
    <AuthModalsContext.Provider value={value}>
      {children}
      <SignInModal open={signInOpen} onOpenChange={setSignInOpen} className={poppins.className} />
      <SignUpModal open={signUpOpen} onOpenChange={setSignUpOpen} className={poppins.className} />
    </AuthModalsContext.Provider>
  )
}

export function useAuthModals() {
  const value = useContext(AuthModalsContext)
  if (!value) throw new Error('useAuthModals must be used inside AuthModalsProvider')
  return value
}
